<template>
  <div class="container">
    <el-row :gutter="10">
      <h3>标注历史</h3>
    </el-row>
    <el-row :gutter="10">
      <h3>审核历史</h3>
     <el-col :span="6">10</el-col>
    </el-row>
    <h3></h3>
  </div>
</template>
<script>
import {mapMutations} from 'vuex';

export default {
  name: '',
  components: {},
  data () {
    return {};
  },
  mounted () {
    this.setSubTitle('用户信息');
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ])
  },
  computed: {}
};
</script>
<style>

</style>
